import React from "react";

export const ColorsSet = [
  "#19cea1",
  "#eaa604",
  "#fc3885",
  "#ad56fb",
  "#4463ff",
  "#f92e32",
  "#fb4913",
  "#282828",
  "#42e871",
  "#ffaa17",
  "#fc2f64",
  "#7a31ff",
  "#08a4ff",
  "#f92e4b",
  "#ea4411",
  "#868686",
  "#3ad1ab",
  "#ffc21f",
  "#d71447",
  "#7a3b9e",
  "#4a63e0",
  "#ef4343",
  "#ff7800",
  "#bdbdbb",
  "#5cf699",
  "#ffd35d",
  "#f24e78",
  "#886cff",
  "#5ba4ff",
  "#fd5f5f",
  "#ff8e70",
  "#e7e7e7",
  "#09bd90",
  "#d6a103",
  "#bb234a",
  "#6e42be",
  "#364fc6",
  "#b12f2f",
  "#d54602",
  "#282829",
  "#0fcd9d",
  "#e8b315",
  "#cf3059",
  "#7b48d5",
  "#445cd6",
  "#dc4242",
  "#eb4f04",
  "#464646",
  "#1fe1af",
  "#f4c127",
  "#e63c69",
  "#905bf1",
  "#4f67e5",
  "#ed4d4d",
  "#f7641e",
  "#696969",
  "#5febc8",
  "#ffd34e",
  "#f2537c",
  "#a171fb",
  "#5c77fc",
  "#f54f4f",
  "#fe7735",
  "#848484",
  "#61f7d1",
  "#ffda68",
  "#fa688d",
  "#bb96ff",
  "#7c92ff",
  "#ff7f7e",
  "#ff8f57",
  "#bdbdbd",
  "#7fffe0",
  "#fee080",
  "#ff86a5",
  "#ccafff",
  "#96a7ff",
  "#fb9fa0",
  "#ffa87d",
  "#dbdbdb",
  "#b0ffea",
  "#ffe79f",
  "#ffa7bf",
  "#d8c2ff",
  "#bbc7fb",
  "#ffc7c8",
  "#ffd1ba",
  "#eeeeee",
  "#cffff3",
  "#fff2cf",
  "#ffd7e2",
  "#ede3fe",
  "#dae0ff",
  "#fff3f3",
  "#ffe4d9",
  "#f8f8f8",
];

export default ColorsSet;
